import { PositionTab } from './PositionTab'
import { PositionTable } from './PositionTable'

export const Position = {
  Tab: PositionTab,
  Table: PositionTable,
}
